import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { services } from "../../config/site";

const Services = () => {
  return (
    <div className="shane_tm_section" id="services">
      <div className="shane_tm_services">
        <div className="container">
          <div className="shane_tm_title">
            <span>שירותי המשרד</span>
            <h2>שירותים משפטיים ותחומי התמחות</h2>
          </div>

          <div className="services_grid">
            {services.map((item, index) => (
              <Link
                to={item.href}
                key={item.slug}
                className="service_card"
                data-aos="fade-up"
                data-aos-duration="900"
                data-aos-delay={index * 60}
              >
                <div className="service_card_inner">
                  <div className="service_icon_wrap">
                    <FontAwesomeIcon
                      icon={item.icon}
                      className="service_icon"
                    />
                  </div>
                  <h3 className="service_title">{item.title}</h3>
                  <p className="service_desc">{item.description}</p>
                  <span className="service_read_more">
                    קרא עוד
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      className="service_read_more_arrow"
                    />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
